import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=2bc4cef7&scoped=true"
import script from "./FileDropzone.vue?vue&type=script&lang=ts"
export * from "./FileDropzone.vue?vue&type=script&lang=ts"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=2bc4cef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4cef7",
  null
  
)

export default component.exports